<template>
<div> 
      <p>Below are competencies you have saved, but the preceptor has not yet been notified of them.</p> 
      <p><strong>This list will only show competencies from before September 22, 2019 if the preceptor was not notified.</strong></p>
        <b-table small show-empty empty-text="You have no saved competencies to send at this time." striped responsive stacked="md" :items="items" :fields="fields">
            <template v-slot:cell(created_at)="row">{{ moment(row.item.created_at).format('MMM DD YYYY') }}</template>
            <template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button-group>
                <b-button @click="emailPreceptor(row.item.id)" class="btn btn-primary">
                <span class="icon icon-paper-plane">
                    Notify</span>
                </b-button>
                <b-button v-if="role == 'student'" @click="editComp(row.item.id)" class="btn btn-warning">
                <span class="icon icon-pencil">
                    Edit</span>
                </b-button>
                <b-button @click="info(row.item.preceptor_name, row.item.id, $event.target)" class="btn btn-danger">
          <span class="icon icon-trash"></span>
            </b-button>
            </b-button-group>
            </template>
             
        </b-table>
       <!-- Info modal2 -->
    <b-modal ok-title="Yes Delete" cancel-title="Cancel" ok-variant="danger" cancel-variant="primary" id="modal2Info" @hide="resetmodal2" @ok="deleteAssessment" :title="modal2Info.title">
      <p>{{ modal2Info.content }}</p>
    </b-modal>
    </div>
</template>

<script>
const items = [];
var moment = require("moment");
export default {
  props: ["user_role"],
  data() {
    return {
      items: items,
      moment: moment,
      role: this.user_role,
      fields: [
        { key: "title", label: "Competency" },
        { key: "standard", label: "Standard" },
        { key: "preceptor_name", label: "Preceptor" },
        { key: "created_at", label: "Saved" },
        { key: "actions", label: "Action" }
      ],
      modal2Info: { title: '', content: '', id: '' }
    };
  },
  methods: {
    emailPreceptor(id) {
      window.location.href = "/competencies/saved/send/" + id;
      // axios
      //   .get("/competencies/saved/send/" + id)
      //   .then(response => (this.items = response.data))
      //   .catch(function(error) {
      //     // handle error
      //     console.log(error);
      //   });
      //   swal({
      //       title: "Email Sent!",
      //       icon: "success",
      //   });
    },
    editComp(id) {
      window.location.href = "/student/edit/sent-competency/" + id;
    },
    info(preceptor_name, id, button) {
        this.modal2Info.title = `Are you sure you want to delete?`,
        this.modal2Info.content = "This competency for " + preceptor_name,
        this.modal2Info.id = id,
        this.$root.$emit('bv::show::modal', 'modal2Info', button)
      },
    resetmodal2() {
        this.modal2Info.title = ''
        this.modal2Info.content = ''
        this.modal2Info.id = ''
    },
    deleteAssessment(id) {
       axios.get('/student/delete/competency/' + this.modal2Info.id)
            .then(response => this.items = response.data)
            .catch(function (error) {
                // handle error
                console.log(error);
            });
            swal({
          title: "Competency Deleted!",
          icon: "success"
        });
         this.modal2Info.title = ''
        this.modal2Info.content = ''
        this.modal2Info.id = ''
    },
  },
  mounted() {
    axios
      .get("/competencies/saved")
      .then(response => (this.items = response.data))
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  }
};
</script>

<!-- table-basic-1.vue -->